import type { MonthPoint } from './metrics';
import { formatFullTL } from './metrics';

/**
 * Trailing-six-month bar column of proposals created per month. Pure CSS —
 * this project draws its charts by hand rather than pulling in a chart library.
 */
export function MonthlyActivity({ months }: { months: MonthPoint[] }) {
  const max = Math.max(1, ...months.map(m => m.count));

  return (
    <div className="px-5 pt-5 pb-4 h-full flex flex-col justify-end">
      <div className="flex items-end justify-between gap-2 flex-1 min-h-[112px]">
        {months.map((m, i) => {
          const isCurrent = i === months.length - 1;
          return (
            <div key={m.key} className="flex-1 flex flex-col items-center justify-end gap-1.5 h-full">
              <span className={`text-[11px] font-semibold tabular-nums ${m.count > 0 ? 'text-stone-700' : 'text-stone-300'}`}>
                {m.count}
              </span>
              <div
                className={`w-full max-w-[34px] rounded-lg transition-all ${isCurrent ? 'bg-[#945f46]' : 'bg-[#945f46]/30'}`}
                style={{ height: `${Math.max(m.count > 0 ? 8 : 3, (m.count / max) * 100)}%` }}
                title={`${m.label}: ${m.count} teklif · ${formatFullTL(m.total)}`}
              />
            </div>
          );
        })}
      </div>
      <div className="mt-2 flex items-center justify-between gap-2">
        {months.map((m, i) => (
          <span
            key={m.key}
            className={`flex-1 text-center text-[10px] font-medium uppercase tracking-wider ${
              i === months.length - 1 ? 'text-stone-800 font-semibold' : 'text-stone-400'
            }`}
          >
            {m.label}
          </span>
        ))}
      </div>
    </div>
  );
}
